import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore, persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage for web
import { combineReducers } from 'redux';
import userReducer from './userSlice';
import customerReducer from './customerSlice';
import internalUsersReducer from './internalUsersSlice';
import productReducer from './productSlice';
import categoryReducer from './categorySlice';
import bannerReducer from "./bannerSlice";
import brandReducer from "./brandSlice";
import roleReducer from './roleSlice';
import officeReducer from './officeSlice';
import businessTypeReducer from './businessTypeSlice';
import forgotPasswordReducer from './forgotPasswordSlice';
import resetPasswordReducer from './resetPasswordSlice';
import emailTemplateReducer from './emailTemplateSlice';
import loginReducer from './loginSlice';
import languageReducer from './languageSlice';
import memberReducer from './memberSlice';
import attributeReducer from './attributeSlice';
import homeReducer from './homeSlice';
import rfqReducer from './rfqSlice';
import notificationReducer from './notificationSlice';
import settingReducer from './settingSlice';
import chatReducer from './chatSlice';
import orderReducer from './orderSlice';
import deliveryUserReducer from './deliveryUserSlice';
import deliveryReducer from './newDeliverySlice';
import appointmentReducer from './appointmentSlice';
import ticketReducer from './ticketSlice';
import leaveReducer from './leaveSlice';
import policyReducer from './policySlice';
import feedbackReducer from './feedbackSlice';
import dashboardReducer from "./dashboardSlice";
import currencyReducer from "./currencySlice"
import currentCurrencyReducer from "./currentCountrySlice";
// persist config
const persistConfig = {
  key: 'root',
  storage,
  timeout: null,
};

// Action type to reset entire store on logout (clears loaders and all slice state)
export const RESET_STORE = 'RESET_STORE';

// combine reducers
const appReducer = combineReducers({
  login: loginReducer,
  user: userReducer,
  customer: customerReducer,
  internalUser: internalUsersReducer,
  product: productReducer,
  category: categoryReducer,
  banner: bannerReducer,
  brand: brandReducer,
  role: roleReducer,
  office: officeReducer,
  businessType: businessTypeReducer,
  forgotPassword: forgotPasswordReducer,
  resetPassword: resetPasswordReducer,
  emailTemplate: emailTemplateReducer,
  language: languageReducer,
  member: memberReducer,
  attribute: attributeReducer,
  home: homeReducer,
  rfq: rfqReducer,
  notification: notificationReducer,
  setting: settingReducer,
  chat: chatReducer,
  order: orderReducer,
  delivery_user: deliveryUserReducer,
  delivery: deliveryReducer,
  appointment: appointmentReducer,
  ticket: ticketReducer,
  leave: leaveReducer,
  policy: policyReducer,
  feedback: feedbackReducer,
  dashboard: dashboardReducer,
  currency: currencyReducer,
  currentCurrency: currentCurrencyReducer
});

// Root reducer: on RESET_STORE, clear all state so every slice returns initial state (loaders reset)
// const rootReducer = (state, action) => {
//   if (action.type === RESET_STORE) {
//     state = undefined;
//   }
//   return appReducer(state, action);
// };

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    storage.removeItem('persist:root');
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

// persist reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware({
  //     serializableCheck: {
  //       ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
  //     },
  //   }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      // serializableCheck: {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      // },
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
